export default defineNuxtRouteMiddleware(async () => {
  const authenticated = await useAuthenticated()
  const token = useCookie('token') // get token from cookies

  authenticated.value = !!token.value
})
